import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import { Link } from '@uhg-abyss/web/ui/Link';
import { ProcessingStatItem } from '../ProcessingStatsItem';

export const ErrorAndWarningCount = ({
  procStatsList,
  onChildValueChange,
  service,
}) => {
  const handleErrorsWarnings = (e) => {
    e.preventDefault();

    onChildValueChange('ENW');
  };
  return service === 'gps' ? (
    <ProcessingStatItem title="Error And Warning Count">
      <Table.Container title="">
        <Table.TableBody>
          <Table.Row>
            <Table.Cell>
              <b>Customer Errors and Warnings</b>
            </Table.Cell>
            <Table.Cell>
              {procStatsList?.errorAndWarningCounts?.customerErrorsAndWarnings}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <b>Eligibility Analyst Errors and Warnings</b>
            </Table.Cell>
            <Table.Cell>
              {
                procStatsList?.errorAndWarningCounts
                  ?.eligibilityAnalystErrorsAndWarnings
              }
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Link onClick={handleErrorsWarnings} href="#">
                Total Errors and Warnings
              </Link>
            </Table.Cell>
            <Table.Cell>
              {procStatsList?.errorAndWarningCounts?.totalErrorsAndWarnings}
            </Table.Cell>
          </Table.Row>
        </Table.TableBody>
      </Table.Container>
    </ProcessingStatItem>
  ) : (
    <ProcessingStatItem title="Error And Warning Count">
      <Table.Container title="">
        <Table.TableBody>
          <Table.Row>
            <Table.Cell>
              <b>Customer Errors and Warnings</b>
            </Table.Cell>
            <Table.Cell>
              {procStatsList?.errorAndWarningCounts?.customerErrorsAndWarnings}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <b>Eligibility Analyst Errors and Warnings</b>
            </Table.Cell>
            <Table.Cell>
              {
                procStatsList?.errorAndWarningCounts
                  ?.eligibilityAnalystErrorsAndWarnings
              }
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Link onClick={handleErrorsWarnings} href="#">
                Total Errors and Warnings
              </Link>
            </Table.Cell>
            <Table.Cell>
              {procStatsList?.errorAndWarningCounts?.totalErrorsAndWarnings}
            </Table.Cell>
          </Table.Row>
        </Table.TableBody>
      </Table.Container>
    </ProcessingStatItem>
  );
};
